import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("gf_admin_token");
  if (adminToken && config.url && (config.url.startsWith("/admin") || config.url.startsWith("/files"))) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${adminToken}`;
    return config;
  }
  const customerToken = localStorage.getItem("gc_customer_token");
  if (customerToken && config.url && (config.url.startsWith("/customer") || config.url.startsWith("/auth/customer/me"))) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${customerToken}`;
  }
  return config;
});
